import { Type } from "@sinclair/typebox";
import SchemaValidator from "../schema-validator";
import { proctoringOptionType } from "../proctoring-profile/schema-validators";
import { OptionalOrNull } from "../shared-schemas";

const studentType = Type.Object({
	id: Type.Number(),
	uuid: Type.String(),
	name: Type.String(),
});

const students = new SchemaValidator(Type.Array(studentType));

const studentId = new SchemaValidator(Type.Object({ id: Type.Number() }));

const exemptions = new SchemaValidator(
	Type.Union([
		Type.Null(),
		Type.Array(
			Type.Object({
				userId: Type.Integer(),
			}),
		),
	]),
);

const accessControlUserInfo = new SchemaValidator(
	Type.Object({
		id: Type.String(),
		name: Type.String(),
		platform: Type.String(),
		instituteId: Type.String(),
		timezone: Type.String(),
	}),
);

const proctoringExemptions = new SchemaValidator(
	Type.Array(
		Type.Object({
			type: Type.String(),
			userId: Type.Integer(),
			accommodationNotes: Type.Optional(Type.String()),
			proctoringOptionProfileId: Type.Optional(Type.Integer()),
		}),
	),
);

const exemptionStatus = new SchemaValidator(
	Type.Object({
		exempt: Type.Boolean(),
		proctoringOption: Type.Optional(proctoringOptionType),
	}),
);

const language = new SchemaValidator(Type.Union([Type.Literal("en"), Type.Literal("fr"), Type.Null()]));

const standaloneAccount = new SchemaValidator(
	Type.Object({
		id: Type.String(),
		userIds: Type.Array(Type.String(), { minItems: 1 }),
	}),
);

const notifications = new SchemaValidator(
	Type.Array(
		Type.Object({
			type: Type.String(),
			details: OptionalOrNull(Type.Unknown()),
		}),
	),
);

export default {
	students,
	studentId,
	exemptions,
	proctoringExemptions,
	exemptionStatus,
	accessControlUserInfo,
	language,
	standaloneAccount,
	notifications,
};
